// It looks like nv is defined when nvd3 is imported, but leave this alone.
/* eslint-disable no-undef */
let Bar_Chart;

let d3;
let nvd3;
var hasProp = {}.hasOwnProperty;

Bar_Chart = require("./bar_chart").default;

class Royalties {
    constructor() {
        let dontEnums;
        let dontEnumsLength;
        let graph_hack;
        let hasDontEnumBug;
        let j;
        let key;
        let keys;
        let len;
        let ref;

        Array.max = array => Math.max(...array);
        Array.min = array => Math.min(...array);

        if (!Object.keys) {
            hasDontEnumBug = true;
            dontEnums = [
                "toString",
                "toLocaleString",
                "valueOf",
                "hasOwnProperty",
                "isPrototypeOf",
                "propertyIsEnumerable",
                "constructor"
            ];
            dontEnumsLength = dontEnums.length;
            ref = {
                toString: null
            };
            for (j = 0, len = ref.length; j < len; j++) {
                key = ref[j];
                hasDontEnumBug = false;
            }
            Object.keys = keys = object => {
                let dontEnum;
                let i;
                let ii;
                let name;
                if (
                    (typeof object !== "object" &&
                        typeof object !== "function") ||
                    object === null
                ) {
                    throw new TypeError("Object.keys called on a non-object");
                }
                keys = [];
                for (name in object) {
                    if (owns(object, name)) {
                        keys.push(name);
                    }
                }
                if (hasDontEnumBug) {
                    i = 0;
                    ii = dontEnumsLength;
                    while (i < ii) {
                        dontEnum = dontEnums[i];
                        if (owns(object, dontEnum)) {
                            keys.push(dontEnum);
                        }
                        i++;
                    }
                }
                return keys;
            };
        }
        graph_hack = () => {
            $(".tick text").attr("dy", "24px");
            return $(".nv-bar text").attr("dy", "-12px");
        };

        class bar_chart extends Bar_Chart {
            render(data, format) {
                let graph;
                graph = this.graph;
                this.remove();
                return nv.addGraph(() => {
                    let chart;
                    chart = nv.models
                        .discreteBarChart()
                        .x(d => d[0])
                        .y(d => d[1])
                        .staggerLabels(false)
                        .tooltips(false)
                        .showValues(true)
                        .showYAxis(false)
                        .transitionDuration(350)
                        .color(d3.scale.ordinal().range(["#4c4c4c"]));
                    chart.xAxis
                        .showMaxMin(false)
                        .tickFormat(d => d3.time.format(format)(new Date(d)));
                    chart.tooltipContent((key, y, e, { series }) => {
                        data = series.values[y - 1];
                        return `<p>$${e}</p>`;
                    });
                    chart.valueFormat(d3.format("$,.2f"));
                    d3.select(graph)
                        .datum(data)
                        .transition()
                        .duration(500)
                        .call(chart);
                    return graph_hack();
                });
            }
        }

        class stacked_chart extends Bar_Chart {
            render(data, format) {
                let graph;
                graph = this.graph;
                this.remove();
                return nv.addGraph(() => {
                    let chart;
                    chart = nv.models.multiBarChart();
                    chart.xAxis
                        .showMaxMin(false)
                        .tickFormat(d => d3.time.format(format)(new Date(d)));
                    chart.tooltipContent((key, y, e, { series }) => {
                        data = series.values[y - 1];
                        return `<p>$${e}  from ${key}</p>`;
                    });
                    chart.reduceXTicks(false);
                    chart.tooltips(true);
                    chart.showLegend(true);
                    chart.showYAxis(false);
                    chart.multibar.stacked(true);
                    chart.showControls(false);
                    chart.yAxis.tickFormat(d3.format(",.2f"));
                    d3.select("#royalty-graph svg")
                        .datum(data)
                        .transition()
                        .duration(500)
                        .call(chart);
                    graph_hack();
                    return $("body").on("click", ".nv-series", e =>
                        graph_hack()
                    );
                });
            }
        }

        $("document").ready(() => {
            Promise.all([
                import(/* webpackChunkName: "nvd3" */ "d3"),
                import(/* webpackChunkName: "nvd3" */ "nvd3")
            ]).then(([module_d3, module_nvd3]) => {
                d3 = module_d3.default;
                nvd3 = module_nvd3.default;

                let $back;
                let $current_year;
                let $forward;
                let $graph_btns;
                let $no_data;
                let $svg;
                let ar;
                let current_graph;
                let data;
                let if_no_data_show_message;
                let json;
                let least_recent_year;
                let most_recent_year;
                let this_year;
                $svg = $("#royalty-graph svg");
                $no_data = $(".no-data-message");
                json = $("#graph-data").data("royalties-json");
                $current_year = $("#current-year");
                $forward = $("#forward");
                $back = $("#back");
                this_year = $current_year.data("year");
                $graph_btns = $("#buttonList li");
                current_graph = "stacked";
                ar = Object.keys(json);
                least_recent_year = Array.min(ar);
                most_recent_year = Array.max(ar);
                if_no_data_show_message = () => {
                    if (this_year === 2012 || this_year === 2013) {
                        if (current_graph === "stacked") {
                            $svg.hide();
                            return $no_data.removeClass("hidden");
                        } else {
                            $svg.show();
                            return $no_data.addClass("hidden");
                        }
                    } else {
                        $svg.show();
                        return $no_data.addClass("hidden");
                    }
                };
                $("#buttonList").on("click", "a", function(e) {
                    let $parent;
                    let $sibling;
                    let $this;
                    e.preventDefault();
                    $this = $(this);
                    $parent = $this.parent();
                    $sibling = $parent.siblings();
                    this_year = $("#current-year").data("year");
                    switch ($this.prop("id")) {
                        case "total-earned":
                            $parent.addClass("active");
                            $sibling.removeClass("active");
                            current_graph = "stacked";
                            if_no_data_show_message();
                            return new stacked_chart(
                                "#royalty-graph svg",
                                data(this_year, "earned"),
                                "%b"
                            );
                        case "total-paid":
                            $parent.addClass("active");
                            $sibling.removeClass("active");
                            current_graph = "bar";
                            if_no_data_show_message();
                            return new bar_chart(
                                "#royalty-graph svg",
                                data(this_year, "paid"),
                                "%b"
                            );
                    }
                });

                $("#year-selection").on("click", "a", function(e) {
                    let $this;
                    e.preventDefault();
                    $this = $(this);
                    switch ($this.prop("id")) {
                        case "back":
                            this_year = this_year - 1;
                            $current_year.html(this_year);
                            $current_year.data("year", this_year);
                            break;
                        case "forward":
                            this_year = this_year + 1;
                            $current_year.html(this_year);
                            $current_year.data("year", this_year);
                    }
                    if (this_year !== most_recent_year) {
                        $forward.removeClass("disabled");
                    }
                    if (this_year === most_recent_year) {
                        $forward.addClass("disabled");
                    }
                    if (this_year !== least_recent_year) {
                        $back.removeClass("disabled");
                    }
                    if (this_year === least_recent_year) {
                        $back.addClass("disabled");
                    }
                    if_no_data_show_message();
                    switch (current_graph) {
                        case "stacked":
                            return new stacked_chart(
                                "#royalty-graph svg",
                                data(this_year, "earned"),
                                "%b"
                            );
                        case "bar":
                            return new bar_chart(
                                "#royalty-graph svg",
                                data(this_year, "paid"),
                                "%b"
                            );
                    }
                });

                data = (year, type) => {
                    let api;
                    let api_array;
                    let current_year;
                    let i;
                    let paid;
                    let purchase;
                    let purchased_array;
                    let royalty_array;
                    let sub;
                    let sub_array;
                    i = 0;
                    sub_array = [];
                    purchased_array = [];
                    api_array = [];
                    royalty_array = [];
                    current_year = json[year];
                    if (current_year) {
                        while (i < current_year.length) {
                            if (current_year[i].total_earned !== void 0) {
                                sub_array.push({
                                    x: new Date(current_year[i].date),
                                    y: parseFloat(
                                        current_year[i].subscription.total
                                    )
                                });
                                purchased_array.push({
                                    x: new Date(current_year[i].date),
                                    y: parseFloat(
                                        current_year[i].purchased.total
                                    )
                                });
                                api_array.push({
                                    x: new Date(current_year[i].date),
                                    y: parseFloat(current_year[i].api.total)
                                });
                                royalty_array.push([
                                    new Date(current_year[i].date),
                                    parseFloat(current_year[i].total_paid)
                                ]);
                            } else {
                                royalty_array.push([
                                    new Date(current_year[i].date),
                                    parseFloat(current_year[i].total_paid)
                                ]);
                            }
                            i++;
                        }
                    }
                    paid = {};
                    sub = {};
                    purchase = {};
                    api = {};

                    paid.key = "Paid";
                    sub.key = "Pro Downloads";
                    purchase.key = "Single Purchases";
                    api.key = "API Uses";

                    sub.color = "#3EA9F5";
                    purchase.color = "#7AC943";
                    api.color = "#1A1A1A";
                    paid.values = royalty_array;
                    sub.values = sub_array;
                    purchase.values = purchased_array;
                    api.values = api_array;
                    if (type === "earned") {
                        return [sub, purchase, api];
                    } else {
                        return [paid];
                    }
                };

                return new stacked_chart(
                    "#royalty-graph svg",
                    data(this_year, "earned"),
                    "%b"
                );
            });
        });

        $("body").on("click", "#sack", e => {
            e.preventDefault();
            $("#cash img").toggleClass("ooooh-coins");
            return setTimeout(
                () => $("#cash img").removeClass("ooooh-coins"),
                1000
            );
        });

        $("body").on("click", "#cash img.ooooh-coins", function(e) {
            console.log("Got it!");
            return $(this)
                .clone()
                .appendTo("#for-keeps");
        });
    }
}

export default Royalties;
